import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'

export interface IVideoAttrFormatter {

    format(obj: any): object
}

export class VideoAttrFormatter implements IVideoAttrFormatter {

    public format(data: any): object {
        if (data) {
            const obj: any = {}
            if (data.id && data.video_id) {
                obj[key.VID_ID] = data.video_id
            } else if(data.id) {
                obj[key.VID_ID] = data.id
            }
            if (data.author) {
                obj[key.VID_AUTHOR] = data.author
            }
            if (data.video_quality) {
                obj[key.VID_QUALITY] = data.video_quality
            }
            if (data.title) {
                obj[key.VID_NAME] = data.title
            }
            if (data.error) {
                obj[key.VID_ERROR_MSG] = data.error
            }
            obj[key.VID_CONT_TYPE] = data.list ? 'List' : 'Video'
            return obj
        }
        return undefined
    }
}
